<template>
  <div class="user-page">
    <MyHeader v-if="flag" />
    <loading v-if="!flag" />

    <div class="content width1200" v-if="flag">
      <div class="left-c">
        <div class="user-info">
          <img src="../image/Mask.png" alt="" />
          <div class="names">
            <p class="name">向一鸣</p>
            <span class="num">编号：344567788</span>
          </div>
        </div>
        <div class="des-text">
          <p class="des-title">姓名</p>
          <div class="des-c">向一鸣</div>
        </div>
        <div class="des-text">
          <p class="des-title">性别</p>
          <div class="des-c">男</div>
        </div>
        <div class="des-text">
          <p class="des-title">院系</p>
          <div class="des-c">教育学院</div>
        </div>
        <div class="des-text">
          <p class="des-title">班级</p>
          <div class="des-c">陶艺3班</div>
        </div>

        <div class="des-text">
          <p class="des-title">手机</p>
          <div class="des-c">18275039580</div>
        </div>

        <div class="des-text">
          <p class="des-title">邮箱</p>
          <div class="des-c">18275@qq.com</div>
        </div>
        <div class="des-text">
          <p class="des-title">竞选感言</p>
          <div class="des-c">
            <div class="des1">
              竞聘成功感言每一次的竞聘对我来说都是一种学习,是经验的积累,也是提高
              自己、锻炼自己的一次机会。竞聘就像一面明镜,是给自己的一个挑
              战,也照耀出了自己到底有多少水平,看到不足和短处,让自已在以
              后的工作中及时填补上,同时也看到了自己和别的优秀人才的差距,
              督促自己以后要加强学习。
            </div>
          </div>
        </div>
        <div class="des-text">
          <p class="des-title">图片</p>
          <div class="des-c">
            <div class="imgs" @click="img">
              <swiper ref="mySwiper" class="swiper" :options="swiperOptions">
                <swiper-slide>
                  <div class="img-item">
                    <viewer :images="imgs">
                      <img
                        class="iimg"
                        src="https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1485012388,2380514454&fm=26&gp=0.jpg"
                      />
                    </viewer>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img-item"></div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img-item"></div>
                </swiper-slide>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
        <div class="des-text">
          <p class="des-title">视频</p>
          <div class="des-c">
            <div class="imgs">
              <swiper ref="mySwiper" class="swiper" :options="swiperOptions">
                <swiper-slide>
                  <div class="img-item"></div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img-item"></div>
                </swiper-slide>
                <swiper-slide>
                  <div class="img-item"></div>
                </swiper-slide>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
        <div class="des-text">
          <p class="des-title">附件</p>
          <div class="des-c">
            <p class="file-c">
              大学生职业计划书
              <img src="../image/fj.png" alt="" />
            </p>
          </div>
        </div>
      </div>

      <div class="right-c">
        <div class="title1">
          <p>打分项</p>
          <div class="you">
            <a-button @click="info">打分说明 ></a-button>
          </div>
        </div>
        <div class="number-box">
          <div class="title2">笔试</div>
          <div class="num-list">
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="op4">修改</span>
              </div>
              <div class="p2">
                <p>填空题</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="op4">修改</span>
              </div>
              <div class="p2">
                <p>填空题</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="op4">修改</span>
              </div>
              <div class="p2">
                <p>填空题</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="op4">修改</span>
              </div>
              <div class="p2">
                <p>填空题</p>
              </div>
            </div>
          </div>
        </div>
        <div class="number-box" style="margin-top: 24px">
          <div class="title2">面试</div>
          <div class="num-list">
            <div class="num-item">
              <div class="p1">
                <p>{{ num }}分</p>
                <span class="" @click="xiu">修改</span>
                <input
                  @keyup.enter="ent"
                  :value="num"
                  v-show="ss"
                  class="inp"
                  type="text"
                />
              </div>
              <div class="p2">
                <p>颜值</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="">修改</span>
              </div>
              <div class="p2">
                <p>能力</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1" style="padding-left: 16px">
                <div></div>
                <span class="">打分</span>
              </div>
              <div class="p2">
                <p>匹配</p>
              </div>
            </div>
            <div class="num-item">
              <div class="p1">
                <p>85分</p>
                <span class="">修改</span>
              </div>
              <div class="p2">
                <p>填空题</p>
              </div>
            </div>
          </div>
        </div>
        <div class="des-cont">
          <p>备注</p>
          <textarea
            name=""
            id=""
            cols="30"
            placeholder="此处为备注信息备注信息备注信息备注信息备注信息备注信息"
            rows="10"
          ></textarea>
        </div>
        <div class="sub-btn" @click="fn1">保存打分</div>
        <div class="users-box">
          <div class="swtc-user">
            <div class="less">上一个</div>
            <div class="user-list">
              <div class="user-l-cn">共计100人 当前位数<span>30</span></div>
              <div class="big">
                <div class="user-item">
                  <span>第31位</span>
                  <p>张小小</p>
                </div>
                <div class="user-item">
                  <span>第31位</span>
                  <p>张小小</p>
                </div>
                <div class="user-item">
                  <span>第31位</span>
                  <p>张小小</p>
                </div>
              </div>
            </div>
            <div class="plus">下一个</div>
          </div>
          <div class="address">
            <p>面试地点：新媒体中心</p>
            <p>面试官：张三</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MyHeader from "@/components/MyHeader.vue";
import loading from "../views/Loading.vue";
import { Modal } from "ant-design-vue";

export default {
  name: "Home",
  data() {
    return {
      ss: false,
      flag: false,
      num: 88,
      swiperOptions: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // Some Swiper option/callback...
      },
    };
  },
  computed: {
    swiper() {
      // return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    fn1() {
      this.$router.push({
        name: "About",
      });
    },
    info() {
      const h = this.$createElement;
      this.$info({
        title: "This is 打分说明",
        content: h("div", {}, [
          h("p", "哈哈哈哈哈哈哈哈哈哈或或或或或或或"),
          h("p", "哈哈哈哈哈哈哈哈哈哈或或或或或或或"),
          h("p", "哈哈哈哈哈哈哈哈哈哈或或或或或或或"),
          h("p", "哈哈哈哈哈哈哈哈哈哈或或或或或或或"),
        ]),
        onOk() {},
      });
    },
    xiu() {
      this.ss = true;
    },
    ent(e) {
      console.log("111");
      this.ss = false;
      this.num = e.target.value;
    },
    img() {},

    fff() {
      console.log("定时器执行");
      var _this = this;
      _this.$http
        .get("")
        .then(function (res) {
          console.log(res);
          _this.flag = true;
        })
        .catch(function (err) {});
    },
  },
  mounted() {
    var _this = this;
    console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
    setTimeout(function () {
      _this.fff();
    }, 1000);
  },
  components: {
    MyHeader,
    loading,
  },
};
</script>
<style lang="less" scoped src="../assets/common.less">
</style>

<style scoped lang="less">
.user-page {
  /deep/ .ant-modal-confirm-content {
    margin-left: 38px;
    height: 100px;
    overflow: hidden;
    overflow-y: scroll;
  }
}
.user-page {
  p {
    margin: 0px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    .left-c {
      width: 520px;
      background: #ffffff;
      .user-info {
        height: 105px;
        padding-left: 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d0d0d0;
        display: flex;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
          border: 1px solid #ffffff;
          border-radius: 100px;
          display: block;
        }
        .names {
          margin-left: 16px;
          .name {
            font-size: 20px;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 600;
          }
          .num {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            font-weight: 400;
            margin-top: 4px;
          }
        }
      }
      .des-text {
        min-height: 56px;
        background: #ffffff;
        padding-left: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #d0d0d0;
        display: flex;
        align-items: center;
        &:last-child {
          border-bottom: none;
        }
        .des-title {
          width: 174px;
          font-weight: 700;
          min-width: 174px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          margin: 0px;
        }
        .des-c {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 24px;
          font-weight: 700;
          display: flex;
          align-items: center;
          width: 260px;
          .des1 {
            padding: 20px 0;
            color: rgba(0, 0, 0, 0.45);
            height: 200px;
            overflow-y: scroll;
          }
          .imgs {
            width: 300px;
            height: 70px;
            .swiper {
              height: 70px;
            }
            .img-item {
              margin: 10px 12px;
            }
            .swiper-slide {
              // left: 11%;
              // margin-right: 13px !important;
            }
            .img-item {
              width: 76px;
              height: 50px;
              background: #d8d8d8;
              margin-top: 10px;
              .iimg {
                width: 100%;
                height: 100%;
              }
            }
          }
          .file-c {
            p {
              font-size: 8px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 12px;
              font-weight: 400;
              margin-right: 20px;
            }
            img {
              width: 26px;
              height: 26px;
            }
          }
        }
      }
    }
    .right-c {
      width: 640px;
      background: #ffffff;
      .title1 {
        height: 101px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        .ant-btn {
          border: none;
        }

        .you {
          float: right;
        }
        p {
          font-size: 28px;
          color: #333333;
          font-weight: 600;
          margin-left: 190px;
        }
        span {
          font-size: 14px;
          color: #777777;
          text-align: center;
          font-weight: 400;
          right: 36px;
          position: absolute;
          top: 0px;
          height: 101px;
          line-height: 101px;
        }
      }
      .number-box {
        margin: 0 26px;
        .title2 {
          font-size: 20px;
          color: #333333;
          line-height: 46px;
          font-weight: 600;
          padding-left: 24px;
        }
        .num-list {
          display: flex;
          .num-item {
            width: 137px;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              right: 0px;
              top: 50%;
              transform: translate(0, -50%);
              width: 2px;
              height: 45px;
              background-color: #d0d0d0;
            }
            .p1 {
              height: 48px;
              display: flex;
              align-items: center;

              box-sizing: border-box;
              padding-left: 25px;
              div {
                width: 72px;
                height: 40px;
                background: #fff8f8;
                border-radius: 2px;
                margin-right: 6px;
              }
              p {
                font-size: 24px;
                color: #333333;
                letter-spacing: 0;
                text-align: center;
                font-weight: 400;

                margin: 0px;
                margin-right: 16px;
              }
              .inp {
                position: absolute;
                top: 12px;
                width: 100px;
                outline: none;
              }
              span {
                font-size: 14px;
                color: #d52929;
                text-align: center;
                font-weight: 700;
                cursor: pointer;
                &.op4 {
                  opacity: 0.4;
                }
              }
            }
            .p2 {
              padding-left: 28px;
              box-sizing: border-box;
              p {
                font-size: 14px;
                margin: 0px;
                color: #777777;
                line-height: 26px;
                font-weight: 700;
              }
            }
          }
        }
      }
      .des-cont {
        margin: 0 26px;
        display: flex;
        margin-top: 24px;
        p {
          width: 70px;
          min-width: 70px;
          font-size: 20px;
          color: #333333;
          line-height: 46px;
          font-weight: 600;
          font-weight: 700;
        }
        textarea {
          background: #f7f7f7;
          border-radius: 2px;
          width: 470px;
          height: 70px;
          background: #f7f7f7;
          border: none;
          border-radius: 2px;
          padding: 10px;
        }
      }
      .sub-btn {
        width: 276px;
        height: 48px;
        background-image: linear-gradient(159deg, #ff5252 0%, #d52929 100%);
        border-radius: 24px;
        margin: 0 auto;
        margin-top: 32px;
        margin-bottom: 30px;
        font-size: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .users-box {
        border-top: 1px solid #d0d0d0;
        padding-top: 50px;

        .swtc-user {
          display: flex;
          justify-content: center;
          .less {
            width: 72px;
            height: 32px;
            background: #cbcbcb;
            border-radius: 5px;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            font-weight: 400;
            cursor: pointer;
          }
          .plus {
            width: 72px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            color: #ffffff;
            line-height: 32px;
            text-align: center;
            font-weight: 400;
            background: #f14545;
            cursor: pointer;
          }
          .user-list {
            width: 260px;
            .big {
              width: 100%;
              height: 100px;
              overflow-y: scroll;
              .user-item {
                margin-bottom: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                  font-size: 16px;
                  color: rgba(0, 0, 0, 0.45);
                  font-weight: 400;
                  margin-right: 10px;
                }
                p {
                  font-size: 16px;
                  color: rgba(0, 0, 0, 0.85);
                  line-height: 11px;
                  font-weight: 400;
                  margin: 0px;
                }
              }
            }
            .user-l-cn {
              height: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.45);
              line-height: 22px;
              font-weight: 400;
              margin-bottom: 17px;
              span {
                color: #d52b2b;
              }
            }
          }
        }
        .address {
          margin-top: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            font-weight: 500;
            margin-right: 24px;
          }
        }
      }
    }
  }
}
</style>
